module.exports = __webpack_public_path__ + "img/banner-TV-1__md--old.a516ca17.jpg";